import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { App as AntdAppContext, ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";
import { setupLanguage } from "translations";
import { AuthProvider } from "~app/Auth/AuthProvider";
import { ReactQueryProvider } from "./reactQueryProvider";
import Router from "./router";

function App() {
  const { locale, messages } = setupLanguage();

  return (
    <AuthProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#00003c",
            colorPrimaryBg: "#d9d9d9",
            fontFamily: "Bebas Neue Pro",
            colorBgSpotlight: "#d9d9d9",
            fontSize: 15,
          },
          components: {
            Layout: {
              headerBg: "#f2f2f2",
              siderBg: "#f2f2f2",
              footerBg: "#26303d",
              footerPadding: "15px",
            },
            List: {
              footerBg: "#ffffff",
              headerBg: "#ffffff",
            },
            Tooltip: {
              // colorBgDefault: "rgba(0,0,0,.8)",
              colorBgBase: "rgba(0,0,0,.8)",
            },
          },
        }}
      >
        <IntlProvider messages={messages} locale={locale}>
          <AntdAppContext>
            <ReactQueryProvider>
              <Router />
              <ReactQueryDevtools initialIsOpen={false} buttonPosition={"top-right"} />
            </ReactQueryProvider>
          </AntdAppContext>
        </IntlProvider>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
